document.addEventListener('alpine:init', () => {
  Alpine.data('testimonialsSlider', () => ({
    color: null,

    init() {
      this.$nextTick(() => {
        this.color = this.$root.querySelector('.swiper-slide')?.dataset.color;

        if (!document.body.classList.contains('wp-admin')) {
          new Swiper(this.$refs.slider, {
            speed: 400,
            slidesPerView: 1,
            autoHeight: true,
            pagination: {
              enabled: true,
              el: '.swiper-pagination',
              clickable: true,
            },
            keyboard: {
              enabled: true,
            },
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
            on: {
              slideChange: (swiper) => {
                this.color = swiper.slides[swiper.activeIndex].dataset.color;
              },
            },
          });
        }
      });
    },
  }));
});